//import '../css/App.css';
import * as React from "react";
import axios from "axios";
import { IconContext } from "react-icons";
import { FaTemperatureHalf } from "react-icons/fa6";
import { MdMyLocation } from "react-icons/md";
import { FaWind } from "react-icons/fa";
import { FaGaugeHigh } from "react-icons/fa6";
import "weather-react-icons/lib/css/weather-icons.css";
import { WeatherIcon } from "weather-react-icons";
import moment from "moment";

// USING: https://docs.openweather.co.uk/current

const Weather = (props: { lat: string; long: string }) => {
  var strURL = "https://api.openweathermap.org/data/2.5/weather";
  var updtSec = 15;
  const [lat, setLat] = React.useState("0");
  const [long, setLong] = React.useState("0");
  const [loading, setLoading] = React.useState(true);
  const [temp, setTemp] = React.useState(0);
  const [elev, setElev] = React.useState(0);
  const [wind, setWind] = React.useState(0);
  const [humid, setHumid] = React.useState(0);
  const [icon, setIcon] = React.useState(800);
  const [iconTxt, setIconTxt] = React.useState("");
  const [locName, setLocName] = React.useState("");
  const [sunrise, setSunrise] = React.useState(0);
  const [sunset, setSunset] = React.useState(0);
  const [dayman, setDayman] = React.useState(true);

  const MyLoader = () => (
    <svg
      className="loader"
      version="1.1"
      id="L5"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      enableBackground="new 0 0 0 0"
    >
      <circle fill="gray" stroke="none" cx="6" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 15 ; 0 -15; 0 15"
          repeatCount="indefinite"
          begin="0.1"
        />
      </circle>
      <circle fill="gray" stroke="none" cx="30" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 10 ; 0 -10; 0 10"
          repeatCount="indefinite"
          begin="0.2"
        />
      </circle>
      <circle fill="gray" stroke="none" cx="54" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 5 ; 0 -5; 0 5"
          repeatCount="indefinite"
          begin="0.3"
        />
      </circle>
    </svg>
  );

  const getWeather = async function () {
    try {
      const params = {
        lat: props.lat,
        lon: props.long,
        appid: "b787d30caa8bc6079b688d30c93ab737",
        units: "imperial",
      };
      //console.log(params);
      var response = await axios.get(strURL, { params });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const setProgress = (
    percent: number,
    sunrise: string | number | Date,
    light: number
  ) => {
    // Get HTML Elements
    const hourHand = document.getElementById("clock-hour-hand");
    const triangle = document.getElementById(
      "triangle"
    ) as unknown as SVGPolygonElement;
    const wrapper = document.getElementById(
      "wrapper"
    ) as unknown as SVGPathElement;
    const day = document.getElementById("day");
    const night = document.getElementById("night");
    const hourText = document.getElementById("hour-text");

    // Define cicumference
    const circumference = 14 * 2 * Math.PI;
    var sunriseTime: any = new Date(sunrise);
    var today: any = new Date();
    var then: any = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      0,
      0,
      0
    );

    // Calculate length of path based on sunset and sunrise time
    const nightTime = ((light / 86400) * 100 * circumference) / 100;
    //const dayTime = ((49786 / 86400) * 100 * circumference) / 100;
    const dayPercent = (nightTime * 360) / circumference;
    //const nightPercent = (dayTime * 360) / circumference;
    var sunriseDiff = ((sunriseTime - then) / 1000 / 86400) * 360;
    hourText
      ? (hourText.innerHTML = ("0" + today.getHours()).slice(-2))
      : (hourText!.innerHTML = "-");
    //console.log(((sunrise - then) / 1000 / 86400) * 360);

    // Apply shift of paths based on time
    wrapper?.setAttribute("d", describeArc(14, 14, 13, 0, 359.999));
    day?.setAttribute(
      "d",
      describeArc(14, 14, 13, sunriseDiff, dayPercent + sunriseDiff)
    );
    night?.setAttribute(
      "d",
      describeArc(14, 14, 13, dayPercent + sunriseDiff, 360 + sunriseDiff)
    );
    var wrapperLength = wrapper?.getTotalLength();

    // Refresh the current time on the ring
    var diff = Math.abs(then - today) / 1000;
    var mytime = diff / 86400;
    setPoint(mytime * 100, wrapperLength, wrapper, hourHand, triangle);
  };

  function setPoint(
    perc: number,
    wrapperLength: number,
    wrapper: SVGPathElement,
    hourHand: HTMLElement | null,
    triangle:
      | { setAttributeNS: (arg0: null, arg1: string, arg2: string) => void }
      | undefined
  ) {
    //the distance on the path where to place the little circle
    let dist = wrapperLength * ((100 - perc) / 100);
    //get the position of a point at the distance dist on the path
    let point = wrapper.getPointAtLength(dist);
    hourHand?.setAttributeNS(null, "cx", `${point.x}`);
    hourHand?.setAttributeNS(null, "cy", `${point.y}`);
    triangle?.setAttributeNS(
      null,
      "transform",
      `rotate(${(perc / 100) * 360},14,14)`
    );
    //triangle?.setAttributeNS(null, "points", `${point.x - 2.5} ${point.y - 2.5}, ${point.x - 3} ${point.y - 2.5}, ${point.x - 2.5} ${point.y - 3}`);
  }

  function polarToCartesian(
    centerX: number,
    centerY: number,
    radius: number,
    angleInDegrees: number
  ) {
    var angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

    return {
      x: centerX + radius * Math.cos(angleInRadians),
      y: centerY + radius * Math.sin(angleInRadians),
    };
  }

  function describeArc(
    x: any,
    y: any,
    radius: any,
    startAngle: number,
    endAngle: number
  ) {
    var start = polarToCartesian(x, y, radius, endAngle);
    var end = polarToCartesian(x, y, radius, startAngle);

    var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

    var d = [
      "M",
      start.x,
      start.y,
      "A",
      radius,
      radius,
      0,
      largeArcFlag,
      0,
      end.x,
      end.y,
    ].join(" ");

    return d;
  }

  const fetchWeather = async () => {
    var nowTime = Math.floor(new Date().getTime() / 1000);
    var varWeather = await getWeather().then((response) => {
      setTemp(response.main.feels_like);
      setWind(response.wind.speed);
      setHumid(response.main.humidity);
      setElev(response.main.pressure);
      setIcon(response.weather[0].icon);
      setIcon(response.weather[0].id);
      setIconTxt(response.weather[0].main);
      setLocName(response.name);
      setSunrise(response.sys.sunrise);
      setSunset(response.sys.sunset);
      var dark = 86400 - (response.sys.sunset - response.sys.sunrise);
      var light = response.sys.sunset - response.sys.sunrise;

      if (nowTime < response.sys.sunset && nowTime > response.sys.sunrise) {
        let pctLight = (response.sys.sunset - nowTime) * 100;
        setDayman(false);
        setProgress(pctLight / light, response.sys.sunrise * 1000, light);
      } else {
        let pctDark = (response.sys.sunrise + 86400 - nowTime) * 100;
        setDayman(true);
        setProgress(pctDark / dark, response.sys.sunrise * 1000, light);
      }
    });
  };

  React.useEffect(() => {
    setLat(props.lat);
    setLong(props.long);

    fetchWeather();
    setLoading(false);

    const interval = setInterval(async () => {
      fetchWeather();
    }, updtSec * 1000);
    return () => clearInterval(interval);
  }, [props.long, props.lat, strURL]);

  // return components
  return (
    <>
      {loading ? (
        MyLoader()
      ) : (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="transparent"
            id="progress-ring"
          >
            <g id="grpWrapper">
              <path id="wrapper" />
              <path id="night" />
              <path id="day" />
              <text
                id="hour-text"
                x="49%"
                y="49%"
                text-anchor="middle"
                dy="0.3em"
              >
                -
              </text>
            </g>
            <polygon
              points="14 4, 13.75 4.5, 14.25 4.5"
              className="triangle"
              id="triangle"
            />
            <circle id="clock-hour-hand" />
          </svg>
          <IconContext.Provider
            value={{ color: "rgb(119, 148, 255)", size: "1.1em" }}
          >
            <div id="weather-bar">
              <span id="weatherIconId">{icon}</span>
              <span>
                <WeatherIcon
                  className="wIcons3"
                  iconId={icon}
                  name="owm"
                  night={dayman}
                />
                <span className="weatherText" id="weather">
                  {iconTxt}
                </span>
              </span>
              {/* <img alt="current" className='wIcons2' id='icon' src={"https://openweathermap.org/img/wn/" + icon + ".png"} /><span className="weatherText" id="weather">{iconTxt}</span> */}
              <span>
                <MdMyLocation />
                <span className="weatherText" id="locName">
                  {locName}
                </span>
              </span>
              <span>
                <FaTemperatureHalf />
                <span className="weatherText" id="temp">
                  {temp}º
                </span>
              </span>
              <span>
                <FaGaugeHigh />
                <span className="weatherText" id="pressure">
                  {elev}hPa
                </span>
              </span>
              <span>
                <FaWind />
                <span className="weatherText" id="wind">
                  {wind}mph
                </span>
              </span>
              <span>
                <i className="wi wi-humidity wIcons3"></i>
                <span className="weatherText" id="humidity">
                  {humid}
                </span>
              </span>
              <span>
                <i className="wi wi-sunrise wIcons3"></i>
                <span className="weatherText" id="sunrise">
                  {moment.unix(sunrise).format("HH:mm")}
                </span>
                &nbsp;&nbsp;
                <i className="wi wi-sunset wIcons3"></i>
                <span className="watherText" id="sunset">
                  {moment.unix(sunset).format("HH:mm")}
                </span>
              </span>
            </div>
          </IconContext.Provider>
        </>
      )}
    </>
  );
};

export default Weather;
